const AddIcon = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="14" height="14" viewBox="0 0 14 14"
		fill="none" stroke="currentColor"
		{...props}
	>
		<path d="M7 3V11" strokeWidth="2" />
		<path d="M3 7H11" strokeWidth="2" />
	</svg>
)

export default AddIcon